export default __webpack_public_path__ + "static/media/start-up.15d48147.svg";